import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Convert = ({ text, language }) => {
  const [convertedText, setConvertedText] = useState('');

  useEffect(() => {
    const response = axios
      .post(
        'https://translation.googleapis.com/language/translate/v2',
        {},
        {
          params: {
            q: text,
            target: language,
            key: 'AIzaSyA9SKZ8IJzq5ZwQpGC21mYqo2iG4SfTQY0'
          }
        }
      )
      .then((response) => {
        setConvertedText(response.data.data.translations[0].translatedText);
      })
      .catch((err) => {
        setConvertedText("No predigas tu futuro; simplemente créalo.");
        console.log('rest api error', err);
      });
  }, [text, language]);

  return <>{convertedText}</>;
};

export default Convert;